<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.region_id"
                  @change="getDistricts"
                  :loading="regionsLoading"
                >
                  <el-option
                    v-for="region in regions"
                    :key="region.id"
                    :value="region.id"
                    :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.district_id"
                  :loading="districtsLoading"
                >
                  <el-option
                    v-for="district in districts"
                    :key="district.id"
                    :value="district.id"
                    :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Ismi Sharifi" prop="fullname">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="form.fullname"
                  type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Telefon raqami" prop="phone">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="form.phone"
                  type="number"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga</el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "ContactsAdd",
  data() {
    return {
      loading: false,
      regionsLoading: false,
      districtsLoading: false,
      regions: [],
      districts: [],
      form: {
        id: null,
        fullname: null,
        district_id: null,
        region_id: null,
        phone: null,
        position: "Bosh mutaxassis",
      },
      rules: {
        title: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        district_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        region_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        citizen_count: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {
            ...this.form,
          };

          if (this.form.id) {
            http = this.$http.put(`/api/v1/contact`, formData);
          } else {
            http = this.$http.post("/api/v1/contact", formData);
          }

          http
            .then(() => {
              ElNotification({
                title: "Tabriklaymiz",
                message: "Muvafaqiyatli saqlandi",
                type: "success",
              });
              this.$router.go(-1);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Xatolik",
                message:
                  response.data.message || "Iltimos, qayta urinib ko'ring.",
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.form.district_id = null;
      this.$http
        .get("/api/v1/districts", {
          params: {
            region_id: this.form.region_id,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },
    getContact(id) {
      this.loading = true;
      this.$http
        .get(`/api/v1/contact`)
        .then(({ data }) => {
          this.form = data.contacts.find((item) => item.id == id);
          console.log(this.form);
          this.getDistrict(this.form.district_id);
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDistrict(id) {
      this.loading = true;
      this.$http
        .get(`/api/v1/districts/${id}`)
        .then(({ data }) => {
          this.districts.push(data);
          //   this.getDistricts();
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getContact(this.$route.params.id);
    }
    this.getRegions();
  },
};
</script>

<style scoped></style>
